import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["connection", "model", "modelsData"]

  connect() {
    // Initialize model dropdown if connection is already selected
    if (this.hasConnectionTarget && this.connectionTarget.value) {
      this.updateModelDropdown()
    }
  }

  connectionChanged() {
    this.updateModelDropdown()
  }

  updateModelDropdown() {
    if (!this.hasModelTarget || !this.hasModelsDataTarget) return

    const selectedOption = this.connectionTarget.selectedOptions[0]
    const provider = selectedOption?.dataset?.provider || ""
    const currentValue = this.modelTarget.value

    // Clear existing options except the placeholder
    this.modelTarget.innerHTML = '<option value="">Select a model...</option>'

    if (!provider) return

    // Get models from the template and filter by provider
    const template = this.modelsDataTarget
    const allOptions = template.content.querySelectorAll("option")

    allOptions.forEach(option => {
      if (option.dataset.provider === provider) {
        const newOption = option.cloneNode(true)
        // Restore selection if this was the previously selected model
        if (newOption.value === currentValue) {
          newOption.selected = true
        }
        this.modelTarget.appendChild(newOption)
      }
    })
  }
}
